import React,{ useState, useEffect } from 'react'
import {
    BrowserRouter as Router,
    useLocation,
    useNavigate
} from "react-router-dom";
import { getLocalStorageItemHandler } from '../service/local-storage';
import { DATA_TYPE, LOCALSTORAGE_KEYS, MONTH } from './enum';
import { DataType } from './regex';

const { object } = DATA_TYPE
const { USER_DATA } = LOCALSTORAGE_KEYS


export const useTimer = ( seconds ) => {
    const [timeLeft, setTimeLeft] = useState(seconds);

    useEffect(() => {

        if (!timeLeft) return;
        const intervalId = setInterval(() => {
            setTimeLeft(timeLeft - 1);
        }, 1000);
        return () => clearInterval(intervalId);
        
    }, [timeLeft]);

    const resetTimer = () => {
        setTimeLeft(seconds)
    }

    return [timeLeft, resetTimer]
};

export const dataCoverter = (data, value) => {
    let newValue = null
    if (data?.type === 'number') {
        newValue = value !== '' && +value < data?.minimum_value ? data?.minimum_value : value?.toString() === '' ? '' : +value > data?.maximum_value ? data?.maximum_value :Number(value?.toString()?.replace(DataType, ''))
    }
    else if (data?.type === 'boolean') {
        newValue = value === false || value?.toUpperCase() === 'FALSE' ? false : true
    }
    else if (data?.type === 'date' && value) {
        let year = new Date(value).getFullYear()
        let month = (new Date(value).getMonth() + 1).toString().length === 1 ? '0'+ (new Date(value).getMonth()+1):new Date(value).getMonth() + 1
        let day = new Date(value).getDate().toString().length === 1 ? '0' + new Date(value).getDate().toString() : new Date(value).getDate().toString()
        newValue = year + "-" + month + "-" + day
    }
    else {
        newValue=value
    }
    return newValue
}

export function useCopyToClipboard(){
    const [copiedText, setCopiedText] = useState(null)

    const copy = async text => {
        if (!navigator?.clipboard) {
            return false
        }
        try {
            await navigator.clipboard.writeText((text))
            setCopiedText(text)
            return true
        } catch (error) {
            setCopiedText(null)
            return false
        }
    }

    return [copiedText, copy]
}

export function useQuery(query) {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search).get(query), [search, query]);
}

export const cleanRequestBodyHandler = (requestObj, sample_request) => {
    let requestObjClone = JSON.parse(JSON.stringify(requestObj))
    for (let key in requestObjClone) { 
        if (Object.keys(requestObjClone[key])?.length && typeof requestObjClone[key] === object) {
            for (let value in requestObjClone[key]) { 
                if (requestObjClone[key][value] === '$$' || requestObjClone[key][value] === '' || requestObjClone[key][value] === undefined) {
                    delete requestObjClone[key][value]
                }
            }
        }
        if (Object.keys(requestObjClone[key])?.length === 0 && (typeof requestObjClone[key] === object && !Array.isArray(requestObjClone[key]))) {
            delete requestObjClone[key]
        }
        if (requestObjClone[key] === '$$' || requestObjClone[key] === '' || requestObjClone[key] === undefined) {
            delete requestObjClone[key]
        }
        
    } 
    return requestObjClone
}   


export const dateFormatHandler = (val) => {
    let date = new Date(val).getDate()
    let month = new Date(val).getMonth()
    let year = new Date(val).getFullYear()

    return MONTH[month] + ' ' + date + ', ' + year
}

export const checkValidEmailHandler = (email) => {
    let domain = email.includes('@') ? email.split('@')[1] : '';

    return domain
}


export const changeDataValueHandler = (requestObj) => {
    for (let key in requestObj) { 
        let hsCd=''
        if (key && key.toLowerCase().includes('hs') && Array.isArray(requestObj[key])) {
           let reqObj=requestObj?.[key]?.map(hsCode => {
                if (hsCode?.includes("HS:") && hsCode?.includes("-")) {
                    hsCd = hsCode?.split(':')?.[1]?.split('-')?.[0]?.trim()
                    return hsCd
                } else {
                    return hsCode
                }
           })
            requestObj[key] = reqObj
        }
    }
}